export const WEBCAM_PROCTORING_INTERVAL = 15 * 1000;
export const VIDEO_PROCTORING_INTERVAL = 1 * 1000;
export const PROCTOR_IMAGE_UPLOAD_RETRY = 1;
export const PROCTOR_IMAGE_UPLOAD_INITIAL_RETRY = 1;
export const PROCTOR_AUDIO_UPLOAD_RETRY = 1;
export const PROCTOR_AUDIO_UPLOAD_BACK_OFF_DELAY = 1000;
export const PROCTOR_IMAGE_UPLOAD_BACK_OFF_DELAY = 5000; // 5 sec
export const FAILED_IMAGE_PROCTOR_UPLOAD_LOCALSTORAGE_KEY =
  'PROCTOR_FAILED_IMAGES';
export const FAILED_IMAGE_PROCTOR_UPLOAD_LOCALSTORAGE_DEFAULT_VALUE = {};
export const FAILED_IMAGE_PROCTOR_UPLOAD_LOCALSTORAGE_MAX_LENGTH = 25;
export const MIME_TYPE_JPEG = 'image/jpeg';
export const MIME_TYPE_WEBP = 'image/webp';

/** `data:` URL prefix for screenshot format checks (before base64 payload). */
export const DATA_URL_IMAGE_PREFIX_JPEG = `data:${MIME_TYPE_JPEG};`;
export const DATA_URL_IMAGE_PREFIX_WEBP = `data:${MIME_TYPE_WEBP};`;

/** JPEG quality when normalizing identity snapshots to JPEG for upload/pipeline. */
export const PROCTOR_IDENTITY_SNAPSHOT_JPEG_QUALITY = 0.9;

/** `verbose` keys passed to `proctoringUBALogger` for identity image / snapshot flow. */
export const PROCTOR_UBA_VERBOSE = {
  IMAGE_CONVERSION_FAILED: 'error:image_conversion_failed',
  IDENTITY_IMAGE_CAPTURED: 'info:identity_image_captured',
  IDENTITY_IMAGE_CAPTURED_FAILED: 'error:identity_image_captured',
};

export const IMAGE_IDENTITY_ERROR_MESSAGE = {
  '5xx':
    'Something went wrong, please retake the snapshot and try to submit identity image again',
  network_error:
    'Please check your internet connection and try to submit identity image again',
  400: 'Image verification failed!',
  404: 'Something went wrong, Please refresh your page and try to submit identity image again',
};

export const AUDIO_SAMPLE_ERROR_MESSAGE = {
  '5xx':
    'Something went wrong, please re-record the audio sample and try to submit again',
  network_error:
    'Please check your internet connection and try to submit audio sample again',
  400: 'Audio sample verification failed!',
  404: 'Something went wrong, Please refresh your page and try to submit audio sample again',
};

export const PROCTOR_SIGNED_URL_DEFAULT_VIDEO_BATCH_SIZE = 50;
export const PROCTOR_SIGNED_URL_DEFAULT_IMAGE_BATCH_SIZE = 50;
export const PROCTOR_SIGNED_URL_INITIAL_BATCH_SIZE = 6;
export const PROCTOR_SIGNED_URL_LOCALSTORAGE_KEY = 'PROCTOR_SIGNED_URLS';
export const PROCTOR_SIGNED_URL_LOCALSTORAGE_DEFAULT_VALUE = {};
export const PROCTOR_BATCH_API_STARTING_SEQUENCE = 6;
export const PROCTOR_SIGNED_URL_RETRY = 1;
export const CAMERA_ACCESS_LOCALSTORAGE_KEY =
  'PROCTORING_CAMERA_PERMISSION_ASKED';
// New proctoring webcam-error auto-submit flow (session-wide timer tracking)
export const WEBCAM_ERROR_START_TIME_LOCALSTORAGE_KEY = 'webcamErrorStartTime'; // epoch ms as string; default null (missing key)
export const WEBCAM_ERROR_DURATION_LOCALSTORAGE_KEY = 'webcamErrorDuration'; // cumulative seconds as string; default 0
export const PROCTOR_FAILED_IMG_COUNTER_LOCALSTORAGE_KEY =
  'PROCTOR_FAILED_IMAGE_COUNTER';
export const PROCTOR_MODE = {
  VIDEO: 'video',
  IMAGE: 'image',
};
export const PROCTOR_TEST_START_TIME_LOCALSTORAGE_KEY =
  'PROCTOR_TEST_START_TIME';
export const PROCTOR_INITIATED_IMAGE_UPLOAD_LOCALSTORAGE_KEY =
  'initiated-image-upload-counter';
export const PROCTOR_SIGNED_URL_COUNTER_LOCALSTORAGE_KEY =
  'signed-url-restapi-counter';
export const PROCTOR_IMAGE_SEQUENCE_DETAILS_LOCALSTORAGE_KEY =
  'PROCTOR_IMAGE_SEQUENCE_DETAILS';
export const PROCTOR_NEXT_IMAGE_SEQUENCE_LOCALSTORAGE_KEY =
  'PROCTOR_NEXT_IMAGE_SEQUENCE';
// VAD Blocking Problem Types - Voice detection should be disabled for these problem types
export const VAD_BLOCKING_PROBLEM_TYPES = ['VID', 'ADO']; // Video, Audio, Text (speech sense)

export const PROCTOR_IMAGE_UPLOAD_STATUS = {
  success: 'success',
  fail: 'fail',
  drop: 'drop',
  webcamError: 'webcamError',
};
export const PROCTOR_AUDIO_UPLOAD_STATUS = {
  success: 'success',
  fail: 'fail',
  drop: 'drop',
  audioError: 'audioError',
};

export const PROCTOR_DROP_IMG_COUNTER_LOCALSTORAGE_KEY =
  'PROCTOR_DROP_IMAGE_COUNTER';
export const PROCTOR_SUCCESS_IMG_COUNTER_LOCALSTORAGE_KEY =
  'PROCTOR_SUCCESS_IMAGE_COUNTER';
export const PROCTOR_SIGNED_URL_FAIL_COUNTER_LOCALSTORAGE_KEY =
  'PROCTOR_SIGNED_URL_FAIL_COUNTER';

export const PROCTOR_BATCHED_SIGNED_URL_FAIL_COUNTER_LOCALSTORAGE_KEY =
  'PROCTOR_BATCHED_SIGNED_URL_FAIL_COUNTER';
export const PROCTOR_BATCHED_SIGNED_URL_API_FAIL_COUNTER_LOCALSTORAGE_KEY =
  'PROCTOR_BATCHED_SIGNED_URL_API_FAIL_COUNTER';
export const PROCTOR_BATCHED_SIGNED_URL_API_SUCCESS_COUNTER_LOCALSTORAGE_KEY =
  'PROCTOR_BATCHED_SIGNED_URL_API_SUCCESS_COUNTER';
export const PROCTOR_BATCHED_SIGNED_NEXT_SEQUENCE_LOCALSTORAGE_KEY =
  'PROCTOR_BATCHED_SIGNED_NEXT_SEQUENCE';

export const PROCTOR_IMAGE_PROCESS_STATUS = {
  fetch: 'fetch',
  upload: 'upload',
  webcamError: 'webcamError',
  uploadNetworkError: 'uploadNetworkError',
  uploadTimeoutError: 'uploadTimeoutError',
};

export const PROCTOR_WEBCAM_ERROR_COUNTER_LOCALSTORAGE_KEY =
  'PROCTOR_WEBCAM_ERROR_COUNTER';

export const PROCTOR_TABID_SESSIONSTORAGE_KEY = 'PROCTOR_TABID';

export const PROCTOR_MACHINE_UUID_SESSIONSTORAGE_KEY = 'machine_uuid';

export const proctorRetryLoaderMessage = seconds =>
  `Redirecting to feedback page in ${seconds} seconds  \nPlease don’t close this window, we are saving your assessment.`;

export const IMAGE_SEQUENCE_IN_RESUMED_TEST_LOCALSTORAGE_KEY =
  'IMAGE_SEQUENCE_IN_RESUMED_TEST';

export const TF_MODEL_LOADED = 'ModelLoaded';

export const PREDICTION_SUCCESS = 'PREDICTION_SUCCESS';

export const SYSTEM_CHECK_SESSION_STORAGE_KEY = 'SYSTEM_CHECK_PASSED';

export const TAB_COMMUNICATION_CHANNEL = 'TAB_COMMUNICATION';
export const MULTI_SESSION_STORAGE_KEY = 'MULTI_SESSION';
export const ACTIVE_USER_SESSION = 'ACTIVE_USER_SESSION';

export const PROCTOR_HEARTBEAT_INTERVAL_SUCCESS = 5000;
export const PROCTOR_HEARTBEAT_INTERVAL_FAILURE = 1000;

// Webcam recovery retries: Fibonacci backoff in **minutes** (stored as ms for setTimeout compatibility)
// 1m, 1m, 2m, 3m, 5m
export const WEBCAM_RECOVERY_FIBONACCI_BACKOFF_MS = [
  1 * 60 * 1000,
  1 * 60 * 1000,
  2 * 60 * 1000,
  3 * 60 * 1000,
  5 * 60 * 1000,
];
